<template>
    <div class="user-settings__top">
        <div class="user-settings__profil">

            <div class="left-one" style="display: flex; align-items: center;">
                <div class="left">
                    <img src="@/assets/img/campuscity-logo.png" alt="" class="user-settings__profil-img"
                        v-if="logo == null">
                    <img :src="logo" alt="" class="user-settings__profil-img" v-else>
                </div>

                <div class="right" style="margin-left: -45px;">
                    <p class="user-settings__profil-name">
                        Hoşgeldin ! </p>
                    <p class="user-settings__profil-mail">
                        {{ firstName }} {{ lastName }}
                    </p>
                    <p class="user-settings__profil-name mail">
                        {{ mail }}
                        <span class="sign-out">
                            <svg class="icon">
                                <use xlink:href="/icon/icons.svg#icon-mail"></use>
                            </svg>
                        </span>
                    </p>
                </div>
            </div>
            <div class="right">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'DormDashboardHead',
  props: {
    firstName: {
      type: String,
      default: ''
    },
    lastName: {
      type: String,
      default: ''
    },
    mail: {
      type: String,
      default: ''
    },
    logo: {
      type: String,
      default: ''
    }
  }
}
</script>
